import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.be{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.bf{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.bg{margin-top:2rem;}.ssr-plugin'
import '.b6{margin-bottom:5rem;}.ssr-plugin'
import '.b5{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="a c i b be"
      >
        <DashboardNavBar />
        <div className="bf a b ab bg b6 b5"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
